import React from 'react';
import { HelpCircle, MapPin, Users, Building } from 'lucide-react';
import CityLandingPage from './CityLandingPage';

const ranchiConfig = {
  city: 'Ranchi',
  state: 'Jharkhand',
  canonicalUrl: 'https://nirvanacareercounselling.com/ranchi',
  title: 'Best Career Counselling in Ranchi | Free First Session | Nirvana',
  description:
    'Expert career counselling in Ranchi for students and professionals. Online sessions with a certified counsellor with 30+ years experience. Free first session. Psychometric assessments, career planning, and college guidance in Jharkhand.',
  keywords:
    'career counselling ranchi, career guidance ranchi, best career counsellor ranchi, career counselling jharkhand, psychometric test ranchi, career assessment ranchi, career guidance ranchi jharkhand, online career counselling ranchi, career counselling for students ranchi, career planning ranchi',
  heroSubtitle: 'Expert Career Guidance for Ranchi — 100% Online Sessions',
  localHighlight:
    "Ranchi is Jharkhand's capital and a growing hub for education, government, and emerging industries. We provide career guidance tailored to Ranchi's unique opportunities — from government jobs and civil services to private sector growth and higher education pathways.",
  showRemoteBanner: true,
  ctaNote: 'Online sessions — attend from anywhere in Ranchi',
  localFAQs: [
    {
      icon: HelpCircle,
      question: 'Is career counselling available in Ranchi?',
      answer:
        'Yes! We provide 100% online career counselling for students and professionals in Ranchi. Our sessions are conducted via video call, making expert career guidance fully accessible from anywhere in the city without any commute.',
    },
    {
      icon: MapPin,
      question: 'What career options are relevant for students in Ranchi?',
      answer:
        'Students in Ranchi often explore government services (UPSC, JPSC), engineering, medicine, management, and emerging fields like IT and finance. We provide comprehensive psychometric assessments and market-aligned guidance to help identify the best-fit career for each individual.',
    },
    {
      icon: Building,
      question: 'Do you provide guidance for government job aspirants in Ranchi?',
      answer:
        'Yes. Many Ranchi clients are preparing for or considering government services. We help assess whether government careers align with your aptitude and personality, and guide you through the options available — including state services, banking, railways, and defence.',
    },
    {
      icon: Users,
      question: 'How do online counselling sessions work for Ranchi clients?',
      answer:
        'Sessions are conducted over video call (Google Meet, Zoom, or similar). You will receive your psychometric assessment reports digitally, and all follow-up materials are shared online. The experience is as effective as an in-person session — many clients report it is more convenient.',
    },
  ],
};

const RanchiPage = () => <CityLandingPage cityConfig={ranchiConfig} />;

export default RanchiPage;
